module.exports = __webpack_public_path__ + "static/ericsson-logo-298826f5d29d5c9ebfb73ae1d8f4100e.png";